import styled from 'styled-components';
import { BannerPrimary } from '../../ui/Banner/styles';
export const Wrapper = styled.div`
  ${BannerPrimary} {
    margin-bottom: 0;
  }
`;
